define(function(require,exports,module){
    var lazyload = {
        init: function(opt) {
            var that = this;
            var op = {
                anim: true
            };
            $.extend(op, opt);
            that.img.init(op);
        
        },
        img: {
            init: function(n) {
                
                var that = this;
                
                function inViewport(el) {
                    var top = window.pageYOffset
                    var btm = window.pageYOffset + window.innerHeight
                    var elTop = $(el).offset().top;
                    var elBtm = elTop + $(el).height() + 100;
                    if(elBtm >= top && elTop <= btm) {
                        return true;
                    } else {
                        return false;
                    }
                    // return elTop >= top && elTop <= btm
                }

                $(document).off('scroll').on('scroll', function() {
                    $('img.lazy').each(function(index, node) {
                        var $this = $(this);
                        if (!$this.attr('dataimg')) {
                            return;
                        }
                        if (!inViewport(this)){
                            return;
                        }
                        if($this.parents(".tabCnt").hasClass("hide")) {
                            return;
                        }
                        if($this.parents(".floor").hasClass("hide")) {
                            return;
                        }
                        act($this);
                    });
                }).trigger('scroll');

                setTimeout(function() {
                    $(document).trigger('scroll');
                }, 300);
                
                function act(_self) {
                    if (_self.attr('loaded'))
                        return;
                    var img = new Image(), original = _self.attr('dataimg')
                    img.onload = function() {
                        _self.attr('src', original).removeClass('lazy');
                        n.anim && _self.css({opacity: .2}).animate({opacity: 1}, 280);
                    }
                    original && (img.src = original);
                    _self.attr('loaded', true);
                }
            }
        }
    };
    exports.fn = lazyload;
});


// WEBPACK FOOTER //
// ./src/js/unit/lazyload/lazyload.js